export { default as useCopyToClipboard } from './useCopyToClipboard';
export * from './useCopyToClipboard';
//# sourceMappingURL=index.js.map